import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { withI18n, withConfig } from 'spa/Components/Context';

import Typography, { TypeVariants } from '@urbanmassage/component-library/lib/Typography/Typography';
import CardOptionsList from '@urbanmassage/component-library/lib/CardOptionsList/CardOptionsList';
import Mail from '@urbanmassage/component-library/lib/Icons/Mail/Mail';
import DeliveryTruck from '@urbanmassage/component-library/lib/Icons/DeliveryTruck/DeliveryTruck';

import eVoucherBg from '../../images/gifts/e-voucher-bg.jpg';
import postalVoucherBg from '../../images/gifts/postal-voucher-bg.jpg';

const GiftsDeliveryOptions = ({
  currencySymbol,
  deliveryOption,
  onSelectDeliveryOption,
}, { i18n, config }) => {
  const showPostalVoucherOption = config.getValue('feature.gift-vouchers.physical-delivery-enabled', i18n.umRegion);

  const eVoucher = {
    label: `${i18n._x('By email', 'Gifts page')}`,
    name: 'delivery-options',
    subLabel: i18n._x('Instant', 'Gifts page'),
    secondaryText: i18n._x('Free', 'Gifts page'),
    value: 'e-voucher',
    backgroundImage: eVoucherBg,
    defaultChecked: deliveryOption.value === 'e-voucher',
    subLabelIcon: <Mail />,
    tooltipText: `${i18n._x('Choose to send your e-voucher straight away or specify a different date.', 'Gifts page')}`,
    price: 0,
  };

  const postalVoucher = {
    label: `${i18n._x('By post', 'Gifts page')}`,
    name: 'delivery-options',
    subLabel: i18n._x('3-5 days', 'Gifts page'),
    secondaryText: i18n._x('Free', 'Gifts page'),
    value: 'postal-voucher',
    backgroundImage: postalVoucherBg,
    defaultChecked: deliveryOption.value === 'postal-voucher',
    subLabelIcon: <DeliveryTruck />,
    tooltipText: `${i18n._x('First class delivery via Royal Mail. Actual delivery times may vary.', 'Gifts page')}`,
    price: 0,
  };

  const deliveryOptions = showPostalVoucherOption ? [eVoucher, postalVoucher] : [eVoucher];

  const handleOnChange = (e) => {
    const { value } = e.target;
    const selectedOption = deliveryOptions.find(option => option.value === value);

    onSelectDeliveryOption({
      label: selectedOption.label,
      value: selectedOption.value,
      price: selectedOption.price,
    });
  };

  const optionsList = {
    options: deliveryOptions,
    onChange: handleOnChange,
  };


  useEffect(() => {
    const savedOption = sessionStorage.getItem('giftsV2') ? JSON.parse(sessionStorage.getItem('giftsV2')).deliveryOption : null; // eslint-disable-line

    if (savedOption && savedOption.value) {
      onSelectDeliveryOption(savedOption);
      return;
    }

    onSelectDeliveryOption({
      label: optionsList.options[0].label,
      value: optionsList.options[0].value,
      price: optionsList.options[0].price,
    });
  }, []);

  return (
    <React.Fragment>
      {deliveryOptions && currencySymbol ? (
        <div className="gifts__delivery-options-wrapper">
          <Typography variant={TypeVariants.h3} className="gifts__delivery-options-text">
            {i18n._x('How shall we send your gift card?', 'Gifts page')}
          </Typography>
          {deliveryOption.value && (
            <CardOptionsList {...optionsList} />
          )}
        </div>
      ) : null}
    </React.Fragment>
  );
};

GiftsDeliveryOptions.propTypes = {
  currencySymbol: PropTypes.string.isRequired,
  onSelectDeliveryOption: PropTypes.func.isRequired,
  deliveryOption: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
    price: PropTypes.number,
  }).isRequired,
};

export default withConfig(withI18n(GiftsDeliveryOptions));



// WEBPACK FOOTER //
// ./spa/Pages/Gifts/GiftsDeliveryOptions.jsx